import styled from 'styled-components';

import { COLORS } from '../../assets/js/constants';

export const View = styled.div`
    ${p => p.extStyle ?? ''};
    padding-right: 6px;
    padding-bottom: 6px;
    ${p => p.customStyles?.view ?? ''};
`;

export const TrackVertical = styled.div`
    ${p => p.extStyle ?? ''};
    right: 0;
    bottom: 2px;
    top: 0;
    width: 4px;
    border-radius: 2px;
    background-color: rgba(0, 0, 0, .05);
    ${p => p.customStyles?.trackVertical ?? ''};
`;

export const ThumbVertical = styled.div`
    ${p => p.extStyle ?? ''};
    width: 4px;
    height: 40px;
    border-radius: 2px;
    background-color: ${COLORS.grey};
    ${p => p.customStyles?.thumbVertical ?? ''};
`;

export const TrackHorizontal = styled.div`
    ${p => p.extStyle ?? ''};
    right: 2px;
    bottom: 0;
    left: 0;
    height: 4px;
    border-radius: 2px;
    background-color: rgba(0, 0, 0, .05);
    ${p => p.customStyles?.trackHorizontal ?? ''};
`;

export const ThumbHorizontal = styled.div`
    ${p => p.extStyle ?? ''};
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background-color: ${COLORS.grey};
    ${p => p.customStyles?.thumbHorizontal ?? ''};
`;
